import { Component } from "react";
import { Dropdown, DropdownItem, DropdownMenu, Stack, DropdownToggle, Container, Form } from "react-bootstrap";
import { AppApiManager } from "../util/appApiManager";
import { FormDisplay } from "../components/formDisplay";
import keycloak from "../util/keycloak";
import { debounce } from "../util/debounce";

const defaultSelections = {
    educatorSelected: undefined,
    formAnswers: undefined,
}

export class FormViewV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultSelections,
            educatorSearch: ''
        }
        this.apiManager = new AppApiManager()
    }
    async componentDidMount() {
        if (!this.apiManager.hasValidAuthToken()) {
            keycloak.login()
            return
        }
        const loadedForms = await this.loadForms()
        this.setState({
            forms: loadedForms,
        })
    }

    async loadForms() {
        const templates = await this.apiManager.getTemplates()
        return templates
    }

    async queryEducators(query) {
        const educatorData = await this.apiManager.getSubjectPage(1, 10, query)
        this.setState({educators: educatorData.subjects})
    }

    toggleFormSelect(field, selectedForm) {
        this.setState({
            [field]: selectedForm
        })
    }
    onFormUpdate = (formAnswers) => {
        this.setState({
            formAnswers
        })
    }

    setSearchValue = debounce(async (e) => {
        this.setState({educatorSearch: e.target.value})
        this.queryEducators(e.target.value)
    }, 500)

    hasEducatorSelected = () => {
        return !!this.state.educatorSelected
    }

    onFormSubmit = async (emptyFormOverride) => {
        let formAnswers = this.state.formAnswers
        if (emptyFormOverride) {
            formAnswers = this.state.formSelection.questions.map((item, idx) => {
                if (this.state.formAnswers[idx] !== null && this.state.formAnswers[idx] !== undefined) {
                    return this.state.formAnswers[idx]
                } else if (item.questionType === 0) {
                    return 'N/A'
                } else {
                    return []
                }
            })
        }
        const success = await this.apiManager.uploadFormResponse(
            this.state.formSelection._id,
            this.state.educatorSelected._id,
            formAnswers
        )
        if (success) {
            alert("Submitted")
            this.setState({...defaultSelections})
            return true
        }
        return false
    }
    render() {
        return (
            <Container className="w-100">
                <Stack direction="horizontal" className="justify-content-around w-75 m-4">
                    <Dropdown>
                        <DropdownToggle variant="secondary">{(this.state.formSelection && this.state.formSelection.templateName) || 'Select form...'}</DropdownToggle>
                        <DropdownMenu>
                            {this.state.forms && this.state.forms.map((val, idx) => 
                                <DropdownItem key={idx} onClick={() => {this.toggleFormSelect('formSelection', val)}}>{val.templateName}</DropdownItem>
                            )}
                        </DropdownMenu>
                    </Dropdown>
                    <Dropdown>
                        <DropdownToggle variant="secondary">{(this.state.educatorSelected && this.state.educatorSelected.name) || 'Select educator...'}</DropdownToggle>
                        <DropdownMenu>
                            <Form.Control 
                                autoFocus
                                className="mx-3 my-2 w-auto"
                                placeholder="Search..."
                                onChange={this.setSearchValue}
                            />
                            {this.state.educators && this.state.educators.map((val, idx) => 
                                <DropdownItem key={idx} onClick={() => {this.toggleFormSelect('educatorSelected', val)}}>{val.name} <small> {val.school}</small></DropdownItem>
                            )}
                        </DropdownMenu>
                    </Dropdown>
                </Stack>
                {this.state.formSelection && 
                    <FormDisplay
                        hasEducatorSelected={this.hasEducatorSelected}
                        onFormUpdate={this.onFormUpdate}
                        onFormSubmit={this.onFormSubmit}
                        templateInfo={this.state.formSelection}
                    />
                }

            </Container>
        )
    }
}